import { render, staticRenderFns } from "./InvoiceTypeSettings.vue?vue&type=template&id=028e6c4c&scoped=true"
import script from "./InvoiceTypeSettings.vue?vue&type=script&lang=js"
export * from "./InvoiceTypeSettings.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTypeSettings.vue?vue&type=style&index=0&id=028e6c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e6c4c",
  null
  
)

export default component.exports